<script>
import appConfig from "@/app.config";

/**
 * Recover-password component
 */
export default {
  page: {
    title: "WaitForApproval",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mounted() {
    document.body.classList.add("authentication-bg");
  },
  data() {
    return {
      title: "WaitForApproval",
    };
  },
};
</script>

<template>
  <div>
   
    <div class=" account-page">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="bg-white px-4 py-5 radius-20">
              <div class="logo-wrap text-center mb-3">
              <img src="@/assets/images/shiftFish-logo.png" alt="" class="img-fluid">
              </div>
              <h1 class="text-center">Thank you for signing up</h1>
              <p class="text-center m-0 p-0">Please wait for approval. Your application is submitted to our customer support. Be patience we'll notify you soon.</p>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
  </div>
</template>
